import type { ReactElement } from 'react';
import React, { useRef } from 'react';
import type { MfaRecoveryCodeRef } from '@hotjar/webapp/features/Mfa/components';
import { MfaRecoveryCode } from '@hotjar/webapp/features/Mfa/components';
import { Button } from '@hotjar/hotsauce';

import { useTranslationWithPrefix } from '@hotjar/translations';
import { MfaEnforceEnableMfaPageStyles } from '../style';

const { Title, Description, ActionBar, DownloadButton, SuccessWrapper, SuccessIcon } =
  MfaEnforceEnableMfaPageStyles;

interface QrCodeStepProps {
  onNext: () => void;
  recoveryCodes: string[];
}

export const RecoveryCodesStep = ({ onNext, recoveryCodes }: QrCodeStepProps): ReactElement => {
  const { t } = useTranslationWithPrefix('mfa:enforce-mfa.recovery-codes');
  const recoveryCodeRef = useRef<MfaRecoveryCodeRef>(null);

  return (
    <>
      <Title>{t('title')}</Title>
      <SuccessWrapper>
        <SuccessIcon icon="check" inline />
        {t('success-message')}
      </SuccessWrapper>

      <Description>
        {t('description-1')}
        <br />
        <br />
        {t('description-2')}
      </Description>

      <MfaRecoveryCode recoveryCodes={recoveryCodes} ref={recoveryCodeRef} />

      <ActionBar marginTop="x4">
        <div>
          <DownloadButton kind="secondary" onClick={() => recoveryCodeRef?.current?.download()}>
            {t('download')}
          </DownloadButton>

          <Button kind="secondary" onClick={() => recoveryCodeRef?.current?.print()}>
            {t('print')}
          </Button>
        </div>

        <Button kind="primary" onClick={onNext} type="submit">
          {t('action')}
        </Button>
      </ActionBar>
    </>
  );
};
